import type { MassEntry, Summary } from "./types";

/** Σ clawback over context blocks — the deprecated body-cracked savings source
 * (the BFF now returns context_blocks: []). Kept for the rollout fallback. */
export const sumClawback = (blocks: MassEntry[]): number =>
  blocks.reduce((a, b) => a + (b.clawback_usd ?? 0), 0);

/** Window $ savings for the overview "Savings" KPI + the trend ratio.
 * Prefer the BFF's byte-derived `savings_usd` (PII-free, cheap); fall back to
 * summing the now-deprecated context_blocks clawbacks so the number stays correct
 * against an older BFF during rollout. Uses `??` (not `||`) so a genuine 0 from
 * `savings_usd` is honored and never replaced by the block sum. */
export const windowSavings = (
  s: Pick<Summary, "savings_usd" | "context_blocks">,
): number => s.savings_usd ?? sumClawback(s.context_blocks);

/** The one "% saved" definition: saved share of GROSS spend (net paid + saved).
 * Used by the overview headline and by every per-agent card, so the two can no
 * longer disagree by basis (OPSS-242 — the agent cards used byte compression).
 * Clamped ≥ 0: the BFF already floors `savings_usd` at 0, but a transformer that
 * grows the payload (pxpipe images text into vision tokens, so bytes rise) must
 * never render as a negative "% saved" if a future basis slips below zero. */
export const savedPct = (saved: number, net: number): number => {
  const gross = net + saved;
  return gross > 0 ? Math.max(0, (saved / gross) * 100) : 0;
};
